<template>
	<f7-popup
		ref="select-agent-popup"
		class="select-agent-popup"
		@popup:opened="opened"
		@popup:close="close"
		:close-by-backdrop-click="true"
		:close-on-escape="true"
	>
		<span class="tint"></span>
		<f7-view url="/payment/create/agents">
		</f7-view>
	</f7-popup>
</template>

<script setup lang="ts">
import ViewPaymentCreateAgentsController
	from "@/targets/light/views/payment-create-agents/ViewPaymentCreateAgentsController";

const controller = ViewPaymentCreateAgentsController.of();
const {paymentError, paymentErrorWasShowed} = controller;

const opened = () => {
	const popupHTML = document.querySelector('.select-agent-popup');
	(popupHTML as HTMLDivElement).classList.add('transition');
}

const close = () => {
	const popupHTML = document.querySelector('.select-agent-popup');
	(popupHTML as HTMLDivElement).classList.remove('transition');

	if (paymentError.value) {
		paymentErrorWasShowed.value = false;
		paymentError.value = null;
	}
}
</script>

<style lang="scss">
.select-agent-popup {
	height: calc(100% - 44px);
	bottom: 0px !important;
	top: unset !important;
	border-top-left-radius: 16px !important;
	border-top-right-radius: 16px !important;

	.tint {
		width: 36px;
		height: 4px;
		position: absolute;
		top: 6px;
		z-index: 9999;
		background: #818E95;
		border-radius: 4px;
		left: 50%;
		-webkit-transform: translateX(-50%);
		transform: translateX(-50%)
	}

	&.transition {
		transition: 0.4s ease height;
	}
}

.with-modal-popup {
	#app {
		.select-agent-popup {
			&.height-100 {
				height: calc(100% - var(--f7-safe-area-top)) !important;
			}
		}
	}
}
</style>
